import React from 'react';
import { Grid, Card, CardContent, Typography, Box} from '@mui/material';
import { Link } from 'react-router-dom';
import './webdevservices.css'; // Import the CSS file
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import webDevelopmentImage from '../../../assests/webdevelopment.jpeg';

const Webdevelopment = () => {
  return (
    <Card className="webdevelopment-card">
      {/* Left side with image */}
      <Grid item xs={12} md={4} className="webdevelopment-image-container">
        <Box
          component="img"
          className="webdevelopment-image"
          alt="Web Development"
          src={webDevelopmentImage}
        />
          <div className="contact-info">
            <Typography variant="h6" component="div" gutterBottom className="contact-title">
              Contact Information
            </Typography>
            <div className="contact-item">
              <PhoneIcon className="contact-icon" />
              <Typography variant="body1" className="contact-text">+919060237575</Typography>
            </div>
            <div className="contact-item">
              <EmailIcon className="contact-icon" />
              <Typography variant="body1" className="contact-text">Faridiakram41@gmail.com</Typography>
            </div>
            <div className="contact-item">
              <LocationOnIcon className="contact-icon" />
              <Typography variant="body1" className="contact-text">Samastipur,Bihar(848101)</Typography>
            </div>
          </div>
        <Link to="/Services">
        
<button className="comic-button">Back</button>

        </Link>
      </Grid>
      
      {/* Right side with content */}
      <Grid item xs={12} md={8} className="webdevelopment-content">
        <CardContent>
          <Typography variant="h4" component="div" gutterBottom className="webdevelopment-title">
            Web Development
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Custom Website Development:</strong> Building responsive websites from scratch tailored to client needs.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>E-commerce Development:</strong> Creating online stores with payment gateways and inventory management.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Content Management Systems (CMS):</strong> Implementing and customizing platforms like WordPress or Drupal.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Single Page Applications (SPA):</strong> Developing dynamic SPAs for enhanced user experiences.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>SEO Optimization:</strong> Enhancing website visibility on search engines.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Website Maintenance:</strong> Providing ongoing support, updates, and security enhancements.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Web Performance Optimization:</strong> Improving site speed and overall performance.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>API Integration:</strong> Connecting third-party services and applications with APIs.
          </Typography>

        
        </CardContent>
      </Grid>
    </Card>
  );
};

export default Webdevelopment;
